import React, { useState, useCallback } from 'react'
import { gql } from 'apollo-boost'
import { useQuery } from '@apollo/react-hooks'
import styled from 'styled-components'
import { Link } from 'react-router-dom'

import { fixTitle } from 'helpers/entities'
import LoadingSpinner from 'components/Spinner/Spinner'
import VideoImage from 'components/ListView/VideoImage'
import { SubTitle } from 'components/Elements'
import routeConfig from 'routeConfig'

import Slider, { SliderItem } from 'components/Slider/Slider'

const Container = styled.div`
  padding-top: 50%;
  position: relative;
  margin-bottom: 1.5rem;
  background: ${p => p.theme.colors.gray1};
`
const Inner = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`
const BannerNav = styled.nav`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
`
const BannerNavBtn = styled.button`
  border: 2px solid white;
  background: ${p => (p.active ? 'white' : 'transparent')};
  height: 1rem;
  width: 1rem;
  display: block;
  border-radius: 50%;
  margin: 0 0.2rem;
  cursor: pointer;
`
const StyledSlider = styled(Slider)`
  width: 100%;
  height: 100%;
`

const Banner = ({ backState }) => {
  const { data, loading } = useQuery(query, {
    variables: {
      first: 3,
      tag: 'featured'
    }
  })
  const items = data && data.posts.nodes
  const [sliderIndex, setSliderIndex] = useState(0)
  const changeSlider = useCallback(
    slider => {
      const details = slider.details()
      setSliderIndex(details.absoluteSlide)
    },
    [setSliderIndex]
  )
  const options = {
    initial: sliderIndex,
    slideChanged: changeSlider
  }
  return (
    <Container>
      <Inner>
        {loading && !items && <LoadingSpinner />}
        {items && (
          <>
            <StyledSlider options={options}>
              {items.map((item, i) => (
                <BannerItem key={i} {...item} backState={backState} />
              ))}
            </StyledSlider>
            <BannerNav>
              {items.map((item, i) => {
                const action = () => setSliderIndex(i)
                return (
                  <BannerNavBtn
                    key={i}
                    onClick={action}
                    active={i === sliderIndex}
                  />
                )
              })}
            </BannerNav>
          </>
        )}
      </Inner>
    </Container>
  )
}

const BannerContainer = styled(Link)`
  display: block;
  & h2 {
    position: absolute;
    left: 2rem;
    top: 2rem;
    color: white;
  }
`

const BannerItem = ({ slug, title, featuredImage, backState }) => {
  const postTitle = fixTitle(title)
  const link = {
    pathname: `${routeConfig.post}/${slug}`,
    state: { postTitle, ...backState }
  }
  return (
    <SliderItem>
      <BannerContainer to={link}>
        <VideoImage image={featuredImage.sourceUrl} />
        <SubTitle mb={0} display={{ xs: 'none', md: 'block' }}>
          {title}
        </SubTitle>
      </BannerContainer>
    </SliderItem>
  )
}

const query = gql`
  query Posts($first: Int!, $tag: String!) {
    posts(first: $first, where: { tag: $tag }) {
      nodes {
        id
        postId
        slug
        title
        featuredImage {
          sourceUrl(size: SLIDES)
        }
      }
    }
  }
`

export default Banner
